import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

import { JwtHelperService } from '@auth0/angular-jwt';

import { Auth0Service } from '@geneplanet/ngx-auth0';

@Injectable({
  providedIn: 'root',
})
export class CustomerCheckService {
  private readonly auth0 = inject(Auth0Service);

  customerExists$: Observable<boolean> = this.auth0.token$.pipe(
    mergeMap((token) => {
      return new Observable<boolean>((observer) => {
        const account = new JwtHelperService().decodeToken(
          JSON.parse((token as string) || '{}').accessToken
        );

        const isCustomer =
          account && !!account['http://schemas.nomnio.com/2017/5/customer'];
        return observer.next(isCustomer);
      });
    })
  );
}
